import type { ShadowFeatureSettings, ShadowValues } from './index';

/** What a shadow switched on without settings of its own draws. */
export const DEFAULT_SHADOW_VALUES: ShadowValues = {
    offsetX: 0,
    offsetY: 0,
    blur: 12,
    spread: 4,
    color: 'rgba(0, 0, 0, .08)',
};

/**
 * The `box-shadow` value for a set of shadow numbers. Plain values rather than
 * the feature's shape, so a widget that still stores `shadowSettings` in its
 * legacy bag formats them the same way.
 */
export function shadowValueVar(
    values: Pick<ShadowValues, 'offsetX' | 'offsetY' | 'blur' | 'spread' | 'color'>
): string {
    return `${values.offsetX}px ${values.offsetY}px ${values.blur}px ${values.spread}px ${values.color}`;
}

/** The `box-shadow` value, or `undefined` with the shadow off. */
export function shadowVar(shadow: ShadowFeatureSettings | undefined): string | undefined {
    if (!shadow?.isEnabled) {
        return undefined;
    }

    return shadowValueVar(shadow.settings ?? DEFAULT_SHADOW_VALUES);
}
